import React, { useState, useEffect, useCallback } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  FileInput,
  Dropdown,
  MessageBox,
  CreateButton,
  ResetButton,
  NumberInput,
} from "../../../components/FormElements";
import API from "../../../api";
import { StyledMicroButton } from '../../../components/Styled';
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../../constants";
import { getBase64, getReturnUrl } from "../../../utils";

const OperatorsCreate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [services, setServices] = useState([]);
  const [servicesId, setServicesId] = useState("");
  const [operatorName, setOperatorName] = useState("");
  const [numberLength, setNumberLength] = useState("");
  const [maxNumberLength, setMaxNumberLength] = useState("");
  const [field1Type, setField1Type] = useState("");
  const [field2Type, setField2Type] = useState("");
  const [field3Type, setField3Type] = useState("");
  const [field4Type, setField4Type] = useState("");
  const [field1TypeDropDownValues, setField1TypeDropDownValues] = useState("");
  const [field2TypeDropDownValues, setField2TypeDropDownValues] = useState("");
  const [field3TypeDropDownValues, setField3TypeDropDownValues] = useState("");
  const [field4TypeDropDownValues, setField4TypeDropDownValues] = useState("");
  const [manualOperatorPattern, setManualOperatorPattern] = useState("");
  const [autoResolveComplaints, setAutoResolveComplaints] = useState("No");
  const [shouldOperatorCheck, setshouldOperatorCheck] = useState("No");
  const [operatorLogo, setOperatorLogo] = useState([]);
  const [operatorLogoBase64, setOperatorLogoBase64] = useState("");
  const [planApiCode, setPlanApiCode] = useState("");
  const [backupPlanApiCode, setBackupPlanApiCode] = useState("");
  const [isSTV, setIsSTV] = useState("No");
  const [isActiveForApiUser, setIsActiveForApiUser] = useState("Active");
  const [isActiveForRetailer, setIsActiveForRetailer] = useState("Active");
  const [complaintStatus, setComplaintStatus] = useState("Active");
  const [chargeBackAmount, setChargeBackAmount] = useState("");
  const [complaintTime, setComplaintTime] = useState("");
  const [field1, setField1] = useState("");
  const [field2, setField2] = useState("");
  const [field3, setField3] = useState("");
  const [field4, setField4] = useState("");
  const [minAmount, setMinAmount] = useState("1");
  const [maxAmount, setMaxAmount] = useState("10000");

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    setServicesId("");
    setOperatorName("");
    setField1Type("");
    setField2Type("");
    setField3Type("");
    setField4Type("");
    setField1TypeDropDownValues("");
    setField2TypeDropDownValues("");
    setField3TypeDropDownValues("");
    setField4TypeDropDownValues("");
    setManualOperatorPattern("");
    setAutoResolveComplaints("No");
    setshouldOperatorCheck("No");
    setNumberLength("");
    setOperatorLogo([]);
    setOperatorLogoBase64("");
    setPlanApiCode("");
    setBackupPlanApiCode("");
    setIsSTV("No");
    setIsActiveForApiUser("Active");
    setIsActiveForRetailer("Active");
    setComplaintStatus("Active");
    setChargeBackAmount(0);
    setComplaintTime(0);
    setField1("");
    setField2("");
    setField3("");
    setField4("");
    setMinAmount("");
    setMaxAmount("");
  };

  const readServices = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get("/recharge-configurations/services")
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setServices(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      servicesId: servicesId,
      operatorName: operatorName,
      operatorLogo: operatorLogoBase64,
      planApiCode: planApiCode,
      backupPlanApiCode: backupPlanApiCode,
      isSTV: isSTV,
      isActiveForApiUser: isActiveForApiUser,
      isActiveForRetailer: isActiveForRetailer,
      complaintStatus: complaintStatus,
      chargeBackAmount: chargeBackAmount,
      complaintTime: complaintTime,
      field1: field1,
      field2: field2,
      field3: field3,
      field4: field4,
      minAmount: minAmount,
      maxAmount: maxAmount,
      manualOperatorPattern: manualOperatorPattern,
      numberLength: numberLength,
      maxNumberLength: maxNumberLength,
      field1Type: field1Type,
      field2Type: field2Type,
      field3Type: field3Type,
      field4Type: field4Type,
      field1TypeDropDownValues: field1TypeDropDownValues,
      field2TypeDropDownValues: field2TypeDropDownValues,
      field3TypeDropDownValues: field3TypeDropDownValues,
      field4TypeDropDownValues: field4TypeDropDownValues,
      shouldOperatorCheck: shouldOperatorCheck,
    };
    API.post("/recharge-configurations/operators", formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          setTimeout(() => {
            resetResponseData();
            window.location.href = getReturnUrl(PERMISSION_TYPES.CREATE);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const addText = (setMethod, value) => {
    setMethod((currentValue) => currentValue + value);
  };

  useEffect(() => {
    if (operatorLogo?.length > 0) {
      getBase64(operatorLogo[0], setOperatorLogoBase64);
    }
  }, [operatorLogo]);

  useEffect(() => {
    readServices();
  }, [readServices]);

  const servicesOptions = [{ title: "-- SELECT SERVICE --", value: "" }];
  services.forEach(({ id, serviceName }) =>
    servicesOptions.push({
      title: serviceName,
      value: id,
    })
  );

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Grid
            columns={
              "calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label required>Service</Label>
                <Dropdown
                  placeholder="Please select service"
                  value={servicesId}
                  onChange={setServicesId}
                  options={servicesOptions}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Is STV</Label>
                <Dropdown
                  placeholder="Please select if operator is stv"
                  value={isSTV}
                  onChange={setIsSTV}
                  options={[
                    {
                      title: "Yes",
                      value: "Yes",
                    },
                    {
                      title: "No",
                      value: "No",
                    },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Is Active For Api User ?</Label>
                <Dropdown
                  placeholder="Please select if operator is active for api user"
                  value={isActiveForApiUser}
                  onChange={setIsActiveForApiUser}
                  options={[
                    {
                      title: "Active",
                      value: "Active",
                    },
                    {
                      title: "Inactive",
                      value: "Inactive",
                    },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Is Active For Other Users ?</Label>
                <Dropdown
                  placeholder="Please select if operator is active for other users"
                  value={isActiveForRetailer}
                  onChange={setIsActiveForRetailer}
                  options={[
                    {
                      title: "Active",
                      value: "Active",
                    },
                    {
                      title: "Inactive",
                      value: "Inactive",
                    },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid
            columns={
              "calc(25% - 11.25px) calc(25% - 11.25px) calc(25% - 11.25px) calc(25% - 11.25px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label required>Operator Name</Label>
                <TextInput
                  value={operatorName}
                  onChange={setOperatorName}
                  placeholder="Please enter operator name"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Min Number Length</Label>
                <TextInput
                  value={numberLength}
                  onChange={setNumberLength}
                  placeholder="Please enter Number Length"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Max Number Length</Label>
                <TextInput
                  value={maxNumberLength}
                  onChange={setMaxNumberLength}
                  placeholder="Please enter Number Length"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label>Plan API Operator Code</Label>
                <TextInput
                  value={planApiCode}
                  onChange={setPlanApiCode}
                  placeholder="Please enter plan api operator code"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
            <GridItem>
              <Fieldset>
                <Label>Backup Plan API Operator Code</Label>
                <TextInput
                  value={backupPlanApiCode}
                  onChange={setBackupPlanApiCode}
                  placeholder="Please enter backup plan api operator code"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Min Amount</Label>
                <NumberInput
                  value={minAmount}
                  onChange={setMinAmount}
                  placeholder="Please enter min amount"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Max Amount</Label>
                <NumberInput
                  value={maxAmount}
                  onChange={setMaxAmount}
                  placeholder="Please enter max amount"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Fieldset>
            <Label>Operator Logo</Label>
            <FileInput
              files={operatorLogo}
              onChange={setOperatorLogo}
              accept="image/*"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 1</Label>
                <TextInput
                  value={field1}
                  onChange={setField1}
                  placeholder="Please enter field 1"
                  maxLength={100}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Field 1 Type</Label>
                <Dropdown
                  placeholder="Select field type"
                  value={field1Type}
                  onChange={setField1Type}
                  options={[
                    { title: "Numeric", value: "Numeric" },
                    { title: "Text", value: "Text" },
                    { title: "Date", value: "Date" },
                    { title: "Drop Down", value: "DropDown" },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            {/* Field 1 Drop Down Values - only show if DropDown selected */}
            {field1Type === "DropDown" && (
              <GridItem>
                <Fieldset>
                  <Label required>Field 1 Drop Down Values</Label>
                  <TextInput
                    value={field1TypeDropDownValues}
                    onChange={setField1TypeDropDownValues}
                    placeholder="Json Array"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            )}
          </Grid>
          <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 2</Label>
                <TextInput
                  value={field2}
                  onChange={setField2}
                  placeholder="Please enter field 2"
                  maxLength={100}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Field 2 Type</Label>
                <Dropdown
                  placeholder="Select field type"
                  value={field2Type}
                  onChange={setField2Type}
                  options={[
                    { title: "Numeric", value: "Numeric" },
                    { title: "Text", value: "Text" },
                    { title: "Date", value: "Date" },
                    { title: "Drop Down", value: "DropDown" },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            {/* Field 1 Drop Down Values - only show if DropDown selected */}
            {field2Type === "DropDown" && (
              <GridItem>
                <Fieldset>
                  <Label required>Field 2 Drop Down Values</Label>
                  <TextInput
                    value={field2TypeDropDownValues}
                    onChange={setField2TypeDropDownValues}
                    placeholder="Json Array"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            )}
          </Grid>
          <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 3</Label>
                <TextInput
                  value={field3}
                  onChange={setField3}
                  placeholder="Please enter field 3"
                  maxLength={100}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Field 3 Type</Label>
                <Dropdown
                  placeholder="Select field type"
                  value={field3Type}
                  onChange={setField3Type}
                  options={[
                    { title: "Numeric", value: "Numeric" },
                    { title: "Text", value: "Text" },
                    { title: "Date", value: "Date" },
                    { title: "Drop Down", value: "DropDown" },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            {/* Field 1 Drop Down Values - only show if DropDown selected */}
            {field3Type === "DropDown" && (
              <GridItem>
                <Fieldset>
                  <Label required>Field 3 Drop Down Values</Label>
                  <TextInput
                    value={field3TypeDropDownValues}
                    onChange={setField3TypeDropDownValues}
                    placeholder="Json Array"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            )}
          </Grid>
          <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 4</Label>
                <TextInput
                  value={field4}
                  onChange={setField4}
                  placeholder="Please enter field 4"
                  maxLength={100}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Field 4 Type</Label>
                <Dropdown
                  placeholder="Select field type"
                  value={field4Type}
                  onChange={setField4Type}
                  options={[
                    { title: "Numeric", value: "Numeric" },
                    { title: "Text", value: "Text" },
                    { title: "Date", value: "Date" },
                    { title: "Drop Down", value: "DropDown" },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            {/* Field 1 Drop Down Values - only show if DropDown selected */}
            {field4Type === "DropDown" && (
              <GridItem>
                <Fieldset>
                  <Label required>Field 4 Drop Down Values</Label>
                  <TextInput
                    value={field4TypeDropDownValues}
                    onChange={setField4TypeDropDownValues}
                    placeholder="Json Array"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            )}
          </Grid>
          {/* <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 1</Label>
                <TextInput
                  value={field1}
                  onChange={setField1}
                  placeholder="Please enter field 1"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label>Field 2</Label>
                <TextInput
                  value={field2}
                  onChange={setField2}
                  placeholder="Please enter field 2"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
            <GridItem>
              <Fieldset>
                <Label>Field 3</Label>
                <TextInput
                  value={field3}
                  onChange={setField3}
                  placeholder="Please enter field 3"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label>Field 4</Label>
                <TextInput
                  value={field4}
                  onChange={setField4}
                  placeholder="Please enter field 4"
                  maxLength={100}
                  disabled={isLoading === true}
                />
              </Fieldset>
            </GridItem>
          </Grid> */}
          <Fieldset>
            <Label required>Manual Operator Pattern</Label>
            <TextInput
              value={manualOperatorPattern}
              onChange={setManualOperatorPattern}
              placeholder="Please enter pattern for manual recharge"
              disabled={isLoading}
            />
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setManualOperatorPattern, '{{{yyyymmddhhmmss}}}')}
            >
              Date Time(YYYYMMDD)
            </StyledMicroButton>
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setManualOperatorPattern, '{{{ddmmyyyyhhmmss}}}')}
            >
              Date Time(DDMMYYYY)
            </StyledMicroButton>
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setManualOperatorPattern, '{{{number}}}')}
            >
              Number
            </StyledMicroButton>
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setManualOperatorPattern, '{{{Character}}}')}
            >
              Charcater
            </StyledMicroButton>
          </Fieldset>
          <Grid columns={"1fr 1fr"}>
            <Fieldset>
              <Label required>Auto Reject Complaints</Label>
              <Dropdown
                placeholder="Select Auto Reject Complaints"
                value={autoResolveComplaints}
                onChange={setAutoResolveComplaints}
                options={[
                  { title: "Yes", value: "Yes" },
                  { title: "No", value: "No" },
                ]}
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Operator Check</Label>
              <Dropdown
                placeholder="Operator Check"
                value={shouldOperatorCheck}
                onChange={setshouldOperatorCheck}
                options={[
                  { title: "Yes", value: "YES" },
                  { title: "No", value: "NO" },
                ]}
                disabled={isLoading}
              />
            </Fieldset>
          </Grid>
          {(window.location.href.includes('remitsarathi.com') ||
            window.location.href.includes('sudhaarpe.com') ||
            window.location.href.includes('localhost')) &&
            <Grid columns={"calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"}>
              <GridItem>
                <Fieldset>
                  <Label required>Complaint Status</Label>
                  <Dropdown
                    placeholder="Please Complaint Setting Status"
                    value={complaintStatus}
                    onChange={setComplaintStatus}
                    options={[
                      {
                        title: "Active",
                        value: "Active",
                      },
                      {
                        title: "Inactive",
                        value: "Inactive",
                      },
                    ]}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Complaint Time</Label>
                  <NumberInput
                    value={complaintTime}
                    onChange={setComplaintTime}
                    placeholder="Please enter Complaint Time"
                    maxLength={100}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Penality</Label>
                  <NumberInput
                    value={chargeBackAmount}
                    onChange={setChargeBackAmount}
                    placeholder="Please Enter Penality"
                    maxLength={100}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          }
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading === true} type="submit">
              Create
            </CreateButton>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer >
    </>
  );
};

export default withAppHOC(OperatorsCreate);
